import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {PageContent} from 'aui-react';

import {routes} from '../../constants/';
import {sendGeneralKbArticleClick} from '../../analytics';

export class Intro extends PureComponent {
    static propTypes = {
        errorsPresentButHidden: PropTypes.bool,
    };

    static defaultProps = {
        errorsPresentButHidden: false,
    };

    static contextTypes = {
        i18n: PropTypes.func,
    };

    onLinkClick = () => sendGeneralKbArticleClick(routes.findTheLogs);

    render() {
        if (!this.props.errorsPresentButHidden) {
            return null;
        }

        return (
            <PageContent>
                <p>
                    <span dangerouslySetInnerHTML={{__html: this.context.i18n('johnson.page.detail.restricted.intro')}} />
                    <a href={routes.findTheLogs} onClick={this.onLinkClick} target="_blank">
                        {this.context.i18n('johnson.check.events.event.kblink')}
                    </a>
                </p>
            </PageContent>
        );
    }
}

const mapStateToProps = state => ({
    errorsPresentButHidden: state.events.errorsPresentButHidden,
});

export default connect(mapStateToProps)(Intro);



// WEBPACK FOOTER //
// ./src/components/Intro/Intro.js